import { useCallback, useEffect } from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import { selectedStudyState } from "features/optimization/state/studyAtoms";
import { apiRenderKeyState } from "shared/state/renderKeyAtoms";
import { authTokenState } from "features/auth/state/authAtoms";
import { fetchStudyStatus } from "features/optimization/api/fetchStudyStatus";

const isSameStatus = (a: unknown, b: unknown): boolean => {
  return JSON.stringify(a) === JSON.stringify(b);
};

export const useOptimizationSelection = () => {
  const [selectedStudy, setSelectedStudy] = useRecoilState(selectedStudyState);
  const authToken = useRecoilValue(authTokenState);
  const renderKey = useRecoilValue(apiRenderKeyState);

  const syncSelectedStudy = useCallback(
    async (name: string) => {
      if (authToken === "") return;

      const status = await fetchStudyStatus(authToken, name);
      setSelectedStudy((prev) => (isSameStatus(prev, status) ? prev : status));
    },
    [authToken, setSelectedStudy]
  );

  const handleSelectedStudyChange = useCallback(
    async (name: string) => {
      if (authToken === "") return;

      const status = await fetchStudyStatus(authToken, name);
      setSelectedStudy(status);
    },
    [authToken, setSelectedStudy]
  );

  // 選択中のstudyの状態を最新化する
  useEffect(() => {
    if (!selectedStudy?.name) return;
    void syncSelectedStudy(selectedStudy.name);
  }, [renderKey, selectedStudy?.name, syncSelectedStudy]);

  return {
    selectedStudyName: selectedStudy?.name || "",
    handleSelectedStudyChange,
  };
};
